import { render, staticRenderFns } from "./StockTrfNew.vue?vue&type=template&id=7efb2a10&"
import script from "./StockTrfNew.vue?vue&type=script&lang=js&"
export * from "./StockTrfNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports